import React from 'react';
import { FormattedNumber } from 'react-intl';

export function amountResolver(amount: number, currency: string) {
  return <FormattedNumber value={amount} style='currency' currency={currency} minimumFractionDigits={0} />; // eslint-disable-line
}
